import { z } from "zod"
import { ProjectSchema } from "./project"

export const EventTypeSchema = z.object({
  id: z.number(),
  project_id: z.number(),
  event_name: z.string(),
  count: z.number().min(0),
  created_at: z.string(),
  updated_at: z.string(),
  project: ProjectSchema.optional(),
})

export type EventType = z.infer<typeof EventTypeSchema>
